import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UsernameValidationService {

  regexTwitter: RegExp = /^[a-zA-Z0-9_@.-]{4,15}$/;
  regexFacebook: RegExp = /^[^\s]{4,99}$/;
  regexTikTok: RegExp = /^[a-zA-Z0-9_@.-]{3,20}$/;
  regexLinkedin: RegExp = /^[a-zA-Z0-9-@.]{3,100}$/;
  regexWhatsApp: RegExp = /^[0-9]{10}$/;
  regexInstagram: RegExp = /^[a-zA-Z0-9_@.-]{5,30}$/;

  constructor() { }

  /*
    1	Facebook
    2	Twitter
    3	Instagram
    4	TikTok
    5	LinkedIn
    6	Whatsapp
  */

  validateRedSocial(event: string, typeNetwork: number): Promise<boolean> {    //aca recibo la cuenta y dependiendo del tipo de red social reviso 
    return new Promise((resolve, reject) => {
    if (!event) resolve(false)
    let regexToValid: RegExp;
    switch(typeNetwork) {
      case 1:
        regexToValid = this.regexFacebook;
        break;
      case 2:
        regexToValid = this.regexTwitter;
        break;
      case 3:
        regexToValid = this.regexInstagram;
        break;
      case 4:
        regexToValid = this.regexTikTok;
        break;
      case 5:
        regexToValid = this.regexLinkedin;
        break;
      case 6:
        regexToValid = this.regexWhatsApp;
        break;
      default:
        resolve(false)
        return
    }
    const valido = regexToValid.test(event);
    resolve(valido);

  });  
 } 
  controlLength(event, typeNetwork): Promise<string> {
    return new Promise((resolve)=> {
      switch(typeNetwork) {
        case 1:
          resolve(event.substring(0,99));
          break;
        case 2:
          resolve(event.substring(0,15));
          break;
        case 3:
          resolve(event.substring(0,30));
          break;
        case 4:
          resolve(event.substring(0,20));
          break;
        case 5:
          resolve(event.substring(0,100));
          break;
        case 6:
          resolve(event.substring(0,10));
          break;
        default:
          resolve(event);
          return;
      }
    });
  }
}
